module.exports = __webpack_public_path__ + "static/media/continue.088100f3.svg";